export function createEmitter() {
    const map = new Map();
    return {
        on(event, handler) {
            let set = map.get(event);
            if (!set) {
                set = new Set();
                map.set(event, set);
            }
            set.add(handler);
            return () => this.off(event, handler);
        },
        off(event, handler) {
            map.get(event)?.delete(handler);
        },
        emit(event, payload) {
            const set = map.get(event);
            if (!set)
                return;
            for (const handler of [...set])
                handler(payload);
        },
        clear() {
            map.clear();
        },
    };
}
//# sourceMappingURL=emitter.js.map